import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';

import { Component, Inject, ElementRef, OnInit, Renderer2, HostListener, OnDestroy, DOCUMENT } from '@angular/core';
import { AuthService } from 'src/app/core/service/auth.service';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { WEB_ROUTES } from 'src/consts/routes';
import { RolePermission } from 'src/consts/common.model';
import { httpVersion, superAdminRoutes } from 'src/consts/http-routes';
import { CommonService } from 'src/app/services/common.service';
import { SocketService } from 'src/app/socket.service';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    NgScrollbarModule,
    MatButtonModule,
    RouterLink,
    MatTooltipModule,
    RouterLinkActive,
    NgClass,
  ],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems!: any;
  public userrole: any;
  public role_permission!: RolePermission;
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  companyName?: string;
  companyLogo?: string;
  companyCode?: string;
  headerHeight = 60;
  currentRoute?: string;
  routerObj;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService,
    private socketService: SocketService
  ) {
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
    this.userrole = localStorage.getItem(localStorageConstants.USERROLE) ? localStorage.getItem(localStorageConstants.USERROLE) : 1;
    this.role_permission = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!)?.role_permission;
    let index = 0;
    this.sidebarItems = [];
    if (this.role_permission?.dashboard.View == true) {
      const reqObj = {
        path: WEB_ROUTES.DASHBOARD,
        title: 'Dashboard',
        iconType: 'material-icons-two-tone',
        icon: 'dashboard',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.vendor.View == true) {
      const reqObj = {
        path: WEB_ROUTES.VENDOR,
        title: 'Vendors',
        iconType: 'material-icons-two-tone',
        icon: 'local_shipping',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.clientJob.View == true) {
      const reqObj = {
        path: WEB_ROUTES.CLIENT,
        title: 'Client/Job Names',
        iconType: 'material-icons-two-tone',
        icon: 'account_circle',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.invoice.View == true) {
      const reqObj = {
        path: 'invoice',
        title: 'Invoices',
        iconType: 'material-icons-two-tone',
        icon: 'receipt',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: 'badge-numberr',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.documents.View == true) {
      const reqObj = {
        path: WEB_ROUTES.SIDEMENU_DOCUMENTS,
        title: 'Documents',
        iconType: 'material-icons-two-tone',
        icon: 'folder',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.reports.View == true) {
      const reqObj = {
        path: WEB_ROUTES.SIDEMENU_REPORTS,
        title: 'Reports',
        iconType: 'material-icons-two-tone',
        icon: 'event_note',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }
    if (this.role_permission?.users.View == true) {
      const reqObj = {
        path: WEB_ROUTES.SIDEMENU_USER,
        title: 'Users',
        iconType: 'material-icons-two-tone',
        icon: 'people',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);

    }

    if (this.role_permission?.settings.View == true) {
      const reqObj = {
        path: WEB_ROUTES.SIDEMENU_SETTINGS,
        title: 'Settings',
        iconType: 'material-icons-two-tone',
        icon: 'settings',
        class: '',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        submenu: [],
      };
      this.sidebarItems.splice(index++, 0, reqObj);
    }



  }
  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }
  ngOnInit() {
    this.getCompanyAndUserPicture();
    if (this.authService.currentUserValue) {
      // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    }
    this.initLeftSidebar();
    this.bodyTag = this.document.body;

    this.socketService.pendingInvoiceCount.subscribe((data) => {
      this.updateInvoiceBadge(data.pending_invoices);
    });
  }

  updateInvoiceBadge(pendingInvoices: number) {
    const invoiceItem = this.sidebarItems.find((item: any) => item.path === 'invoice');
    if (invoiceItem) {
      invoiceItem.badge = pendingInvoices >= 0 ? pendingInvoices.toString() : ''; // Set badge if there are pending invoices
    }
  }
  async getCompanyAndUserPicture() {
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_COMPANY_AND_USER_PROFILE);
    if (data.status) {
      this.companyLogo = data.data.company.companylogo;
      this.companyName = data.data.company.companyname;
      this.companyCode = data.data.company.companycode;
    }
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }
  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
}
